import React, { useEffect } from "react";

const PrivacyPolicy = ({ isOpen, onClose }) => {
  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto bg-white p-4 md:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        {/* Terms and Conditions Content */}
        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-black mb-4">Privacy Policy</h2>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              1. Purpose of Agreement
            </h3>
            <p className="text-labelTextColor text-sm">
              This User Agreement outlines the terms and conditions between the
              business owner ("The Business") and Learn Local ("The Platform")
              for hosting educational experiences for children.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              2. Liability and Insurance
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business acknowledges that Learn Local is not liable for any
              incidents, accidents, or damages. The Business must maintain
              liability insurance for all hosted experiences.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              3. Commitment to Scheduled Events
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business must minimize cancellations and notify Learn Local
              immediately if a cancellation is necessary.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              4. Safe and Kid-Centric Experiences
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business must provide a safe and educational environment,
              ensuring experiences are age-appropriate and engaging.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              5. Safety and Conduct
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business must follow safety protocols, ensure respectful
              conduct, and create a non-discriminatory environment.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              6. Advertising and Promotion
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business is encouraged to promote their experiences using
              #LearnLocal and may not advertise on external platforms without
              approval.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              7. Interaction with Attendees
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business must interact with attendees respectfully and ensure
              clear communication with guardians.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              8. Privacy and Data Protection
            </h3>
            <p className="text-labelTextColor text-sm">
              Personal data collected must be handled responsibly and in
              compliance with privacy laws.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              9. Compliance with Laws and Policies
            </h3>
            <p className="text-labelTextColor text-sm">
              The Business is responsible for complying with all legal
              regulations and Learn Local policies.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              10. Intellectual Property
            </h3>
            <p className="text-labelTextColor text-sm">
              Any use of Learn Local’s branding requires approval, and Learn
              Local may share promotional content created during experiences.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              11. Amendments to Agreement
            </h3>
            <p className="text-labelTextColor text-sm">
              Learn Local reserves the right to update this agreement, and
              continued use constitutes acceptance of changes.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-secondaryText mb-2">
              12. Termination of Agreement
            </h3>
            <p className="text-labelTextColor text-sm">
              Learn Local may terminate the agreement if terms are violated or
              if actions conflict with its mission.
            </p>
          </div>
          <div>
            <p className="text-labelTextColor text-sm">
              <span className="text-lg font-semibold text-secondaryText mr-1">
                Acceptance of Agreement{" "}
              </span>{" "}
              By creating a business profile and registering to host experiences
              on Learn Local, The Business acknowledges and accepts all terms
              and conditions outlined in this agreement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
